import { render, staticRenderFns } from "./app.vue?vue&type=template&id=081effd0&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&lang=css&"
import style1 from "./app.vue?vue&type=style&index=1&id=081effd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081effd0",
  null
  
)

component.options.__file = "app.vue"
export default component.exports